// @flow
// Settings configured here will be merged into the final config object.

/**
 * Configurations for the categories
 *
 * @typedef {string} BackgroundColor - The background color of the top image
 * field
 * @typedef {string} GradientEndColor - The color of the bottom right corner
 * @typedef {string} GradientStartColor - The color of the gradient start
 * @typedef {string} MenuColor - The Semantic UI color to use in the menu
 * @typedef {string} shortName
 *
 * @typedef {[BackgroundColor, GradientEndColor, GradientStartColor,
 *   MenuColor, shortName]} CategoryDefinitions
 */

export default {
  categories: {
    'Die 25 besten Winterhotels mit 5 Sternen': [
      'rgba(214, 173, 115, 1)',
      '#a47a00',
      'rgba(214, 173, 115, 0)',
      '5 Sterne'
    ],
    'Die 25 besten Winterhotels mit 4 Sternen': [
      'rgba(181,211,241,1)',
      '#779FBF',
      'rgba(216,230,242,0)',
      '4 Sterne'
    ],
    'Die 25 besten Winterhotels mit 3 Sternen': [
      'rgba(165, 131, 87, 1)',
      '#824e23',
      'rgba(165, 131, 87, 0)',
      '3 Sterne'
    ]
  },
  textToClassName: (str: string) => str.toLowerCase().replace(/\W/g, '-')
}
